import api from "./api";

export const getBranches = async () => {
  return await api.get("/Branches");
};

export const getExpectedPayments = async () => {
  return await api.get("/transaction/expected");
};

export const getNotifications = async () => {
  return await api.get("/Notifications");
};

export const getPatients = async () => {
  return await api.get("/Patients");
};

export const getPatient = async (cardorPhoneNo: string) => {
  return await api.get("/Patient/bycardorPhone", {
    params: { cardorPhone: cardorPhoneNo },
  });
};

export const getTakenTreatments = async (patientId: number) => {
  return await api.get("/TakenTreatment", { params: { patientId } });
};

export const getStaffs = async () => {
  return await api.get("/staffs");
};

export const getUsers = async () => {
  return await api.get("/users");
};

export const getUnRegisteredStaffs = async () => {
  return await api.get("/Staff/UnRegistered");
};

export const getRoles = async () => {
  return await api.get("/Roles");
};

export const getTreatments = async () => {
  return await api.get("/Treatment");
};

export const getOwnerCount = async () => {
  return await api.get("/ownerCount");
};

export const getBranchCount = async () => {
  return await api.get("/branchCount");
};

export const getNextStates = async (from: number) => {
  return await api.get("/nextStates", { params: { fromState: from } });
};

export const getTransactions = async (data: any) => {
  return await api.get("/Transactions", {
    params: {
      branchId: data?.branchId ? data?.branchId : undefined,
      year: data?.year,
      start: data?.start ? data.start : "2000-01-01",
      end: data?.end ? data.end : new Date().toISOString().substring(0, 10),
      cardorPhone: data?.cardorPhone,
    },
  });
};

export const getTransactionSummaries = async () => {
  return await api.get("/transaction/summary");
};

export const getPatientSummaries = async () => {
  return await api.get("/patient/summary");
};
